import { Head } from "@inertiajs/react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import LogMinutesCard from "@/components/schools/LogMinutesCard";
import { formatRoom } from "@/lib/classroom";

/**
 * Bulk minute logging for one classroom. The form lives in
 * LogMinutesCard so the help centre can render it as a "screenshot".
 *
 * student_ids lives inside useForm's state (not a separate useState) so
 * it's in the POST body: Inertia v2 silently ignores the `transform`
 * post-option. See test/smoke/teacher_minute_logging.mjs.
 */
export default function LogMinutes({ school, membership, campaign, classroom, students, submit_path, cancel_path }) {
  const room = formatRoom(classroom.name);

  return (
    <SchoolLayout
      school={school}
      membership={membership}
      eyebrow={campaign.name}
      title={`Log minutes for ${room}`}
      back={{ href: cancel_path, label: room }}
    >
      <Head title={`Log minutes · ${room}`} />

      <div>
        <LogMinutesCard students={students} submit_path={submit_path} />
      </div>
    </SchoolLayout>
  );
}
